import ProfilApi from "./ProfilApi";

export default ProfilApi;
